import { HtmlText } from '@Components/BigBrowse/GridCardMesh/Components/Texts/HtmlText';
import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type {
  PlaneSize,
  PlaneTypes,
} from '@Components/BigBrowse/Model/ModelTypes';
import { Box } from '@react-three/flex';
import { observer } from 'mobx-react-lite';

type Props = {
  gridCard: GridCard<PlaneTypes.Layout_HeroAndText_TextPart>;
};

export const HeroAndTextTitleLine = observer(function HeroAndTextTitleLine({
  gridCard,
}: Props) {
  const { titleColumn, title } = gridCard.data!.styles!.textPart!;

  const textSize: PlaneSize = {
    width: titleColumn!.size.width,
    height: title!.size.height,
  };

  return (
    <Box
      width={titleColumn?.size.width}
      height={titleColumn?.size.height}
      centerAnchor
    >
      <HtmlText size={textSize} {...title!.props} />
    </Box>
  );
});
